export default __webpack_public_path__ + "static/media/milkshake@3x.159b96da.jpg";